export const testimonials = [
  {
    id: "indo-eropa",
    quote:
      "O3S helped us transform our digital presence in just a few weeks. The team understood our vision and delivered beyond expectations. It's rare to find a partner who combines technical expertise with genuine business understanding.",
    name: "Dionisius Velma",
    role: "Founder",
    company: "INDO EROPA",
    initials: "DV",
  },

  // Add future testimonials here:
  // {
  //   id: "client-name",
  //   quote: "Client testimonial...",
  //   name: "Client Name",
  //   role: "Founder",
  //   company: "Company Name",
  //   initials: "CN",
  // },
];
